// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6cc48eab","455":"e9e4739e","977":"5bce567f"}[chunkId] + ".chunk.js";
};